module.exports = __webpack_public_path__ + "media/not2.35fd1ad0.mp4";